import React, {useState} from 'react';
import CheckboxInput from "../../../Components/Inputs/CheckboxInput";
import StandardModal from "../../../Components/Modals/StandardModal";
import PropTypes from "prop-types";

const CategoryTermsCheckbox = (props) => {
    const [showTermsModal, setShowTermsModal] = useState(false);

    return (<>
        <CheckboxInput
            label={<span>I accept the</span>}
            name="terms_accepted"
            checked={props.checked}
            onChange={(e) => props.onChange('terms_accepted', e.target.checked)}
            labelPlacement="end"
        />
        {/* Terms & conditions link needs to live outside the checkbox label so clicking doesn't check the box */}
        <a onClick={(e) => setShowTermsModal(true)}
           className="checkbox-label"
            style={{
                display: 'inline-block',
                fontSize: '0.75rem',
                position: 'relative',
                left: '-0.7rem',
                marginBottom: '1.6rem',
            }}
        >
            Terms & Conditions
        </a>
        <StandardModal
            title="Terms & Conditions"
            open={showTermsModal}
            onClose={(e) => setShowTermsModal(false)}
            isScrollable
            style={{
                width: 600,
            }}
        >
            <div dangerouslySetInnerHTML={{ __html: props.terms }}
                className="margin-bottom-1"
            />
        </StandardModal>
    </>)
}

CategoryTermsCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    terms: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
}

CategoryTermsCheckbox.defaultProps = {

}

export default CategoryTermsCheckbox;
